import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=436276b6&"
import script from "./Invite.vue?vue&type=script&lang=js&"
export * from "./Invite.vue?vue&type=script&lang=js&"
import style0 from "./Invite.vue?vue&type=style&index=0&id=436276b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports